<div class="ba-link-head">
    @if (nachrichtType === NachrichtenTypeEnum.AA) {
        <p class="ba-message-sender-ba">
            {{ 'mailbox.employment-agency' | i18next }}
        </p>
    } @else if (nachrichtType === NachrichtenTypeEnum.JC) {
        <p class="ba-message-sender-jc">
            {{ 'mailbox.jobcenter' | i18next }}
        </p>
    }

    <p aria-hidden="true" id="datetime-{{ nachrichtId }}">{{ dateTime }}</p>
    <h3 class="h4 ba-message-subject" id="betreff-{{ nachrichtId }}">
        {{ betreff }}
    </h3>

    @if (vNiveauAusreichend) {
        <a
                [routerLink]="nachrichtReadLink"
                id="read-{{ nachrichtId }}"
                [attr.aria-label]="ariaLabel"
                [attr.title]="title"
        ></a>
    } @else {
        <a
                href="#"
                id="read-{{ nachrichtId }}"
                [attr.aria-label]="ariaLabel"
                [attr.title]="title"
                (click)="stepUp($event)"
        ></a>
    }

    <p id="bezug-{{ nachrichtId }}">
        @if (showBezug) {
            {{ bezug }}
        }
        @if (erstleser) {
            <span id="firstread-{{ nachrichtId }}"><br/>{{ erstLeserDisplay }}</span>
        }
        @if (vertreter) {
            <span id="vertreter-{{ nachrichtId }}"><br/>{{ vertreterDisplay }}</span>
        }
    </p>
</div>

@if (!vNiveauAusreichend) {
    <span
            class="ba-trust-badge {{ getTrustLevelIcon() }}"
            id="batch-{{ nachrichtId }}"
            [attr.title]="trustLevelLabel"></span>
}

@if (vertreter) {
    <span
            class="ba-icon-persons ba-vertreter-badge"
            [class.ba-badge-first]="vNiveauAusreichend"
            [class.ba-badge-second]="!vNiveauAusreichend"
            [attr.title]="vertreterLabel">
    </span>
}

@if (mitAnhang) {
    <span class="ba-icon ba-icon-mail-attachment" id="attachment-{{ nachrichtId }}"></span>
}

<pf-nachricht-action-buttons
        [nachrichtActions]="nachrichtActions"
        [nachrichtId]="nachrichtId"
        [nachrichtFolder]="nachrichtFolder"
        (buttonClicked)="buttonClicked.emit($event)"
>
</pf-nachricht-action-buttons>
<div i18nRerenderOnLanguageChange></div>